import React, { useCallback } from "react";
import { IGenericModalProps } from "./interface";
import { Modal } from "src/assets/imports/antdComponents";
import "./style.css";

const InfoModal: React.FC<IGenericModalProps> = ({ isModalOpen, closeModal, footerContent, title, width, status, onOk, confirmLoading, centered, bodyContent, className }) => {
	const getHeaderStyles = (status) => {
		const baseStyles = {
			boxShadow: "0px 4px 16px 0px var(neutral-black-opacity-10)",
			height: "4rem",
			padding: "1.25rem 1.5rem",
			margin: 0,
		};

		switch (status) {
			case "success":
				return { ...baseStyles, background: "var(--neutral-white)" };
			case "info":
				return { ...baseStyles, background: "#FFF9E6" };
			case "error":
				return { ...baseStyles, background: "#FFF1F0" };
			default:
				return { ...baseStyles, background: "var(--neutral-white)" };
		}
	};

	const modalStyles = {
		header: getHeaderStyles(status),
		body: { padding: "1.5rem 0.8rem 1rem 1.5rem" },
		mask: { backdropFilter: "blur(3px)", background: "rgba(0, 0, 0, 0)" },
		footer: { padding: "1.5rem", margin: 0 },
		content: { padding: 0, margin: 0 },
	};

	const handleCloseModal = useCallback(() => {
		closeModal();
	}, []);

	const getInfoIconColor = (status) => {
		switch (status) {
			case "success":
				return "#52c41a"; // Green color for success
			case "info":
				return "#FFBF00"; // Blue color for info
			case "error":
				return "#f5222d"; // Red color for error
			default:
				return "#000000"; // Black color for default
		}
	};

	const titleContent = (
		<div className="flex gap-2 items-center color-[--secondary-color]">
			<i className="material-symbols-outlined" style={{ color: getInfoIconColor(status) }}>
				info
			</i>
			<span>{title}</span>
		</div>
	);

	return (
		<Modal
			zIndex={1105}
			centered={centered || true}
			title={titleContent}
			open={isModalOpen}
			onCancel={handleCloseModal}
			footer={footerContent}
			width={width}
			className={`info-modal ${className}`}
			onOk={onOk}
			confirmLoading={confirmLoading}
			styles={modalStyles}>
			{bodyContent}
		</Modal>
	);
};

export default InfoModal;
